const collection = {
    slug: "comme-des-garcons-homme-plus-1990aw-adult-delinquents-guide",
    metaTitle:
      "コムデギャルソンオムプリュス 1990AW 大人の不良とは｜コムデギャルソン買取・レンタルガイド",
    metaDescription:
      "COMME des GARCONS HOMME PLUS 1990-1991AW『大人の不良』を解説。広い身幅、パワーショルダー、長いコート、太いパンツ、柔らかなウール、スピンドル使いのレーヨンコート、ウール地へのオーバープリントから、成熟した不良性を読み解きます。コムデギャルソンオムプリュス買取、COMME des GARCONS買取、レンタル体験へ案内します。",
    metaKeywords:
      "コムデギャルソンオムプリュス 1990AW,コムデギャルソンオムプリュス 1990-1991AW,COMME des GARCONS HOMME PLUS 1990AW,COMME des GARCONS HOMME PLUS 1990-1991AW,大人の不良,コムデギャルソン 大人の不良,オムプリュス 大人の不良,COMME des GARCONS HOMME PLUS 大人の不良,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソンオムプリュス アーカイブ,オムプリュス アーカイブ,コムデギャルソンオムプリュス 名作,オムプリュス 90年代,コムデギャルソン 90年代,ジョン ケール コムデギャルソン,トム ノベンバー コムデギャルソン,パワーショルダー,広い身幅,ヤクザスーツ,ウール オーバープリント,レーヨン コート,スピンドル コート,コムデギャルソン レンタル,COMME des GARCONS レンタル,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-homme-plus-1990aw-adult-delinquents-guide",
    heroImage:
      "media/archive_fashion/archive23.png",
    heroImageAlt:
      "COMME des GARCONS HOMME PLUS 1990-1991AW 大人の不良を解説するEnclopediaアーカイブガイド画像",
    heroNumber: "23 / ADULT DELINQUENTS",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARCONS HOMME PLUS 1990-1991AW『大人の不良』",
    lead:
      "COMME des GARCONS HOMME PLUS 1990-1991AW『大人の不良』。\n\nこのテーマを読むとき、ジョン・ケールやトム・ノベンバーの起用、柔らかな色のウール、スピンドル使いのレーヨンコート、ウール地へのオーバープリントは重要な手がかりになります。\n\nただし、それらはこのコレクションを説明するための入口であって、記事の中心に置きすぎるべきではありません。\n\nEnclopediaが注目するのは、ルック全体から立ち上がる“シルエットとしての大人の不良”です。\n\n広く取られた身幅。\n強い肩。\n縦に落ちる長いコート。\n身体を包むウールの量感。\n太さと余白を持ったパンツ。\nそして、ただ大きいだけではない、妙に整った威圧感。\n\nこのバランスには、以前取り上げたYohji Yamamotoのヤクザスーツにも通じる空気があります。\nスーツやコートを正しく着るのではなく、身体の周囲に“余白”と“迫力”をまとわせる。\n\nここでの不良は、若さの反抗ではありません。\n声を荒げる不良でもありません。\n社会のルールを知ったうえで、服の着方、立ち方、身体の見せ方で少し外れる大人です。\n\nEnclopediaでは、このシーズンを、公式紹介文の情報だけでなく、広い身幅、パワーショルダー、余裕のあるコート、柔らかな素材に宿る威圧感から読み解きます。",
    keywordLine: [
      "adult delinquents",
      "90s homme plus",
      "power shoulder",
      "comme des garcons buyback",
    ],
    thesis:
      "1990-1991AW『大人の不良』の重要性は、ジョン・ケールやトム・ノベンバーの起用だけでなく、広い身幅、パワーショルダー、長いコート、柔らかなウール、落ち感のあるレーヨン、太いパンツによって、成熟した男の威圧感と余裕をシルエットとして作った点にあります。",
    whyTitle:
      "なぜHOMME PLUSは“不良”を“大人”として描いたのか。",
    whyBody:
      "不良という言葉には、若さ、反抗、粗さ、危うさのイメージがあります。\n\nしかしCOMME des GARCONS HOMME PLUS 1990-1991AWで描かれたのは、若い不良ではありません。\n大人の不良です。\n\nこれは非常に重要です。\n\n若い不良は、社会に反発する存在として分かりやすい。\nしかし大人の不良は、もっと複雑です。\n社会のルールを知っている。\n服の着方も分かっている。\nそれでも、完全には従わない。\n\nつまり、ここでの不良性は、壊すことではなく、距離を取ることにあります。\n\n柔らかな色のウールや、スピンドル使いのレーヨンコートは、強い反抗のための服ではありません。\nむしろ、落ち着きや余裕を持ちながら、どこか普通ではない。\n\nウール地へのオーバープリントも同じです。\n本来なら上質さや温かさを感じさせるウールに、印刷という別の表面を重ねる。\n素材の品の良さを保ちながら、そこに違和感を入れる。\n\nEnclopediaでは、この文脈を入口に、COMME des GARCONS HOMME PLUS 1990AWの買取相談、COMME des GARCONS全体のレンタル体験、そしてブランド理解へつなげます。",
    pillars: [
      {
        number: "01",
        title: "SILHOUETTE AS ATTITUDE",
        text:
          "このシーズンの不良性は、柄や装飾だけではなく、広い身幅、強い肩、長い着丈、太いパンツによって作られています。大人の不良は、シルエットとして立ち上がります。",
      },
      {
        number: "02",
        title: "SOFT MATERIAL, HARD PRESENCE",
        text:
          "柔らかな色のウールやレーヨンコートは、乱暴な服ではありません。しかし布量、落ち感、肩の強さによって、静かな威圧感が生まれます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "1990-1991AWは、90年代HOMME PLUSの初期文脈、テーマ性、素材実験、シルエットの強さが重なるシーズンです。買取では単なる古い服ではなく、時代と思想を含めて確認する必要があります。",
      },
    ],
    readingTitle:
      "広い身幅、パワーショルダー、柔らかなウール、ヤクザスーツ的な余白から読む1990-1991AW。",
    readingIntro:
      "このシーズンは、“大人の不良”という言葉や出演モデルだけで読むと浅くなります。重要なのは、その不良性がどのようなシルエットで作られているかです。広く取られた身幅、強い肩、長いコート、柔らかく落ちる素材、太いパンツ。その視覚的な迫力は、単なるオーバーサイズではなく、社会から少し外れた大人の身体の見せ方として成立しています。",
    observations: [
      {
        index: "01",
        title:
          "“大人の不良”は、まずシルエットで作られている",
        text:
          "ルック全体に共通するのは、身体の周囲に大きく余白を取るシルエットです。\n広い身幅、強い肩、長い着丈、太いパンツ。\n\n服が身体に沿って整えるのではなく、身体の外側にもう一つの輪郭を作っている。\n\nこの外側の輪郭が、“大人の不良”という人物像を作っています。\n不良性は、柄や装飾だけで表現されているのではありません。\n立ったときの面積、肩の張り、布の量、身体から服が離れる距離によって作られています。",
      },
      {
        index: "02",
        title:
          "広い身幅は、だらしなさではなく余裕である",
        text:
          "1990-1991AWのルックには、広く取られた身幅が印象的に見られます。\n\nただし、それは単なるサイズの大きさではありません。\n大人の不良に必要なのは、若い反抗の細さや鋭さではなく、余裕です。\n\n身体にぴったり沿う服は、緊張や管理を感じさせます。\n一方で、広い身幅は、身体と服の間に空間を作る。\n\nその空間が、落ち着き、威圧感、近寄りがたさを生みます。\n\n大人の不良は、服で身体を誇示するのではなく、服の余白で存在感を出すのです。",
      },
      {
        index: "03",
        title:
          "パワーショルダーが、静かな威圧感を作る",
        text:
          "このシーズンでは、肩の強さも重要です。\n\nパワーショルダーは、身体を大きく見せるための分かりやすい手法です。\nしかしHOMME PLUSの肩は、単に筋肉質に見せるためのものではありません。\n\n広い身幅と組み合わさることで、肩は社会的な威圧感を作ります。\nスーツやコートの肩が強いと、身体は実際よりも大きく、重く、動かしにくい存在に見える。\n\nこの“動かない強さ”が、大人の不良らしさにつながります。\n\n若い不良が素早く動く存在だとすれば、大人の不良は動かなくても場を支配する存在です。",
      },
      {
        index: "04",
        title:
          "ヤクザスーツにも通じる、身体の外側に作る迫力",
        text:
          "このシーズンのシルエットには、以前取り上げたヤクザスーツにも通じる感覚があります。\n\n広い肩。\n余裕のある身幅。\n長い着丈。\n太いパンツ。\n身体そのものよりも、服が作る外側の輪郭が大きく見える。\n\nこれは、単なるクラシックなスーツの美しさではありません。\n服が身体を社会的に整えるのではなく、身体の周囲に迫力を作る。\n\nヤクザスーツが持っていた“近寄りがたさ”や“余裕のある危うさ”に近いものが、1990-1991AWのHOMME PLUSにも見えます。\n\nただし、HOMME PLUSの場合はそれを暴力的に見せず、柔らかな素材や色で包んでいる点が重要です。",
      },
      {
        index: "05",
        title:
          "柔らかなウールが、強いシルエットを粗暴にしない",
        text:
          "広い身幅や強い肩は、ともすれば粗暴に見えます。\n\nしかしこのシーズンでは、柔らかな色のウールがその印象を和らげています。\n\n不良というテーマでありながら、黒一色のレザーや鋭い金属装飾に寄せない。\n柔らかな色、温かみのある素材、ウールの厚み。\n\nその結果、服は荒々しい反抗ではなく、落ち着いた逸脱として見えます。\n\nここが“大人”である理由です。\n強いシルエットを持ちながら、素材は乱暴ではない。\n威圧感があるのに、品が残っている。",
      },
      {
        index: "06",
        title:
          "レーヨンコートの落ち感が、不良性を流動的にする",
        text:
          "スピンドル使いのレーヨンコートは、このシーズンの視覚的な特徴を考えるうえで重要です。\n\nレーヨンは、ウールとは違う落ち感を持ちます。\n身体に硬く乗るのではなく、重力に沿って流れる。\n\nそこにスピンドルが加わることで、服は固定された形ではなくなります。\n締める、緩める、垂らす、揺れる。\n\n大人の不良は、服を正しく着る人ではありません。\n自分の癖として着る人です。\n\nレーヨンコートの柔らかさとスピンドルの不安定さは、その“着崩しの余地”を作っています。",
      },
      {
        index: "07",
        title:
          "オーバープリントは、素材の品の良さを少し汚す",
        text:
          "ウール地へのオーバープリントは、素材実験として重要です。\n\nウールは本来、上質さ、温かさ、落ち着きと結びつく素材です。\nそこに印刷を重ねることで、素材の表面に別の情報が乗る。\n\nこれは、素材を完全に壊す行為ではありません。\n上品なまま、少しだけ普通ではなくする。\n\n大人の不良というテーマにおいて、この“少し汚す”感覚は非常に効いています。\nきちんとした素材なのに、表面に違和感がある。\n真面目な服なのに、どこか外れている。\n\nHOMME PLUSらしい不良性は、こうした素材の表面にも現れています。",
      },
      {
        index: "08",
        title:
          "ジョン・ケールとトム・ノベンバーは、テーマの証明ではなく雰囲気を補強する存在",
        text:
          "ジョン・ケールやトム・ノベンバーの出演は、このシーズンの印象を強くしています。\n\nただし、記事の中心を人物紹介に置きすぎると、コレクションの視覚的な強さが見えにくくなります。\n\n彼らの役割は、“大人の不良”というテーマを説明することではなく、その空気を補強することです。\n\n音楽や映画の背景を持つ人物が、広い身幅のジャケットや落ち感のあるコートを着る。\nすると服は単なるランウェイピースではなく、履歴を持った人物の服に見えます。\n\nこの効果によって、シルエットに物語性が加わります。",
      },
      {
        index: "09",
        title:
          "この服は、若く見せるための服ではない",
        text:
          "多くのファッションは、若く見せること、細く見せること、軽く見せることへ向かいます。\n\nしかし1990-1991AWのHOMME PLUSは違います。\n\n広い肩。\n太い身幅。\n重さのある素材。\n長いコート。\n\nこれらは、若く軽く見せるための要素ではありません。\nむしろ、年齢や経験を受け止めるための服です。\n\n“大人の不良”というテーマが強いのは、服が若さに逃げていないからです。\n成熟した身体に、余白と迫力を与える。\nそこに、このシーズンの魅力があります。",
      },
      {
        index: "10",
        title:
          "心理的に惹かれるのは、“こういう大人になりたい”という自己投影である",
        text:
          "このシーズンの服が強く見える理由は、単にデザインが珍しいからではありません。\n\n見る人は、服そのものだけでなく、その服を着る人物像に惹かれます。\n流行に従いすぎない。\n社会に馴染みすぎない。\nしかし子どもっぽく反抗するわけでもない。\n\nこういう大人になりたい。\nこういう距離感で服を着たい。\n\nその自己投影が、大人の不良というテーマを強くしています。\n\nEnclopediaでは、この心理を、購入だけでなくレンタル体験へ接続します。\n所有する前に、その人物像を一度身体で試すことができるからです。",
      },
      {
        index: "11",
        title:
          "90年代HOMME PLUSの価値は、今の服にはない余白にある",
        text:
          "1990年代初頭のHOMME PLUSには、現在の服とは違う余白があります。\n\n大きすぎるようで、ただのオーバーサイズではない。\n柔らかいようで、どこか鋭い。\nクラシックに見えるのに、素材や着方に違和感がある。\n\nこの曖昧さは、現代の過剰に整理された服には少ないものです。\n\nだから1990-1991AWのようなシーズンは、単なる古着としてではなく、男性服の態度を記録したアーカイブとして価値があります。",
      },
      {
        index: "12",
        title:
          "買取で見るべきなのは、AD1990だけではなくシルエットの強さ",
        text:
          "COMME des GARCONS HOMME PLUS 1990-1991AWの買取では、AD1990という年代だけで判断するべきではありません。\n\n大人の不良期に該当するか。\n広い身幅、強い肩、長い着丈、太いパンツのようなシルエットがあるか。\n柔らかなウール、レーヨン、スピンドル、オーバープリントの特徴があるか。\n状態、素材表記、品質タグ、保管状態はどうか。\n\nこのシーズンは、テーマ性だけでなく視覚的なシルエットの強さが価値になります。\nEnclopediaでは、HOMME PLUSを単なるブランド古着としてではなく、シーズン背景と現在の需要まで含めて査定します。",
      },
      {
        index: "13",
        title:
          "レンタルで分かるのは、布の量が作る迫力である",
        text:
          "このシーズンの服は、画像だけでは分かりにくい部分があります。\n\n肩の張り。\n身幅の広さ。\nウールの重さ。\nレーヨンの落ち感。\nスピンドルの揺れ。\nパンツの太さ。\n\n実際に着ると、単に古い服ではなく、布の量とシルエットで人物像を作る服だと分かります。\n\n大人の不良は、細部の装飾だけではなく、身体の周囲にどれだけ空間を持つかで成立します。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります。",
      },
    ],
    quote:
      "大人の不良とは、派手に反抗する人ではない。広い肩と身幅、柔らかな素材、余裕のある布量で、社会から少し距離を取る人のことです。",
    perspectiveTitle:
      "Enclopediaは、COMME des GARCONS HOMME PLUSを“古い服”ではなく“身体の輪郭に態度が残るアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "1990-1991AW『大人の不良』を、人物、素材、シルエット、着こなし、時代背景から読み解き、HOMME PLUSが作った男性像を整理します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "大人の不良期の服は、実際に着ることで理解が深まります。広い身幅、パワーショルダー、ウールの柔らかさ、レーヨンの落ち感、スピンドルの揺れをレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "AD1990、素材、オーバープリント、スピンドル、シルエット、状態を確認することで、COMME des GARCONS HOMME PLUSの一着がアーカイブとしてどう評価されるのかが見えてきます。",
      },
    ],
    experienceTitle:
      "COMME des GARCONS HOMME PLUS 1990AWを売る前に、その一着が“大人の不良”の文脈にあるかを確認する。",
    experienceBody:
      "COMME des GARCONS HOMME PLUS 1990-1991AWの買取では、ブランド名やAD1990という年代だけでなく、シーズンテーマ、シルエット、素材、ディテール、状態、サイズ、現在の需要が重要です。\n\n特に『大人の不良』期は、広い身幅、パワーショルダー、長いコート、太いパンツ、柔らかな色のウール、スピンドル使いのレーヨンコート、ウール地へのオーバープリントなど、視覚的な迫力と素材実験が重なります。\n\nEnclopediaが見ているのは1990AWだけではありません。\nCOMME des GARCONS HOMME PLUS全般、COMME des GARCONS、COMME des GARCONS HOMME、JUNYA WATANABE、BLACK COMME des GARCONSなど、コムデギャルソン全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\n大人の不良期を知ることは、自分の持っている一着が“ただの古いジャケット”なのか、“HOMME PLUSの男性像を残すアーカイブ”なのかを見極める入口になります。",
    experienceItems: [
      "COMME des GARCONS HOMME PLUS 1990-1991AWのタグ・AD表記・シーズンを確認する",
      "大人の不良期に近いジャケット、コート、パンツ、セットアップを撮影する",
      "広い身幅、パワーショルダー、長い着丈、太いパンツなどシルエットの特徴を確認する",
      "柔らかな色のウール、レーヨン、スピンドル、オーバープリントの有無を確認する",
      "肩幅、身幅、着丈、パンツの太さなど90年代HOMME PLUSらしい余白を確認する",
      "素材表記、品質タグ、状態、虫食い、毛羽立ち、裏地、ボタン欠損を確認する",
      "1990AWか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "1990AW『大人の不良』を入口に、COMME des GARCONS HOMME PLUSの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARCONS HOMME PLUSを単なるブランド古着としてではなく、川久保玲の男性服への問い、シーズン背景、シルエット、素材実験、現在の需要まで含めて見ています。この記事で1990AW『大人の不良』の重要性に触れた方は、所有しているHOMME PLUSの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARCONS HOMME PLUS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons-homme-plus",
        productImage: "",
        text:
          "1990AW『大人の不良』を含むCOMME des GARCONS HOMME PLUSのジャケット、コート、パンツ、セットアップ、素材実験の強いアーカイブまで。オムプリュスの買取対象と査定視点を確認できます。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "COMME des GARCONS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons",
        productImage: "",
        text:
          "COMME des GARCONS、HOMME PLUS、HOMME、SHIRT、JUNYA WATANABEなど、コムデギャルソン全体の買取相談へ進めます。",
      },
      {
        label: "RENTAL FOCUS 03",
        title: "レンタルできるCOMME des GARCONS HOMME PLUSを見る",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "COMME des GARCONS HOMME PLUSのシーズン性やシルエットは、実際に着ることで理解が深まります。Enclopediaでオムプリュスのアーカイブを体験できます。",
      },
      {
        label: "LINE FOCUS 04",
        title: "大人の不良を読んだら、次はHOMME PLUSの価値を相談する",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "AD1990、広い身幅、パワーショルダー、ウール、レーヨン、スピンドル、オーバープリントなどの特徴が分かる写真をLINEでお送りください。Enclopediaが文脈込みで確認します。",
      },
    ],
    finalCta: {
      title:
        "大人の不良を読んだら、次はCOMME des GARCONS HOMME PLUSの価値を相談する。",
      body:
        "COMME des GARCONS HOMME PLUS 1990-1991AW『大人の不良』は、若さの反抗ではなく、成熟した逸脱をシルエットで表現した重要シーズンです。\nEnclopediaでは、1990AWの買取相談を入口に、HOMME PLUS全体のレンタル体験やCOMME des GARCONS全体の買取相談へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "COMME des GARCONS HOMME PLUSをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;